import {Button, ButtonSize, ButtonStyle} from '@mintdata-wsp/common/components/button/Button';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./Dialog.less');
const cx = classnames.bind(styles);

export interface IDialogProps
{
    className?:string;
    onEnterKey?:(event:React.KeyboardEvent<any>) => (void);
    onBodyMouseDown?:(event:React.MouseEvent<any>) => (void);
    title?:string;
    titleClassName?:string;
    titleIntent?:MDIntent;
    onClose?:(event:React.MouseEvent<any>) => (void);
}

export class Dialog extends React.Component<IDialogProps, any>
{
    private _ref:HTMLElement;

    @bind
    private _onRef(ref:HTMLElement):void
    {
        this._ref = ref;
    }

    componentDidMount():void
    {
        this._focusIfNeeded();
    }

    componentWillReceiveProps(nextProps:Readonly<IDialogProps>, nextContext:any):void
    {
        this._focusIfNeeded();
    }

    @bind
    private _focusIfNeeded():void
    {
        const {onEnterKey} = this.props;

        if( onEnterKey && typeof onEnterKey === 'function' && this._ref )
            this._ref.focus();
    }

    @bind
    private _onKeyPress(event:React.KeyboardEvent<HTMLDivElement>):void
    {
        const {onEnterKey} = this.props;
        if( onEnterKey && typeof onEnterKey === 'function' )
        {
            if( event.key.toLowerCase() === 'enter' )
                onEnterKey(event);
        }
    }

    @bind
    private _onBodyMouseDown(event:React.MouseEvent<HTMLDivElement>):void
    {
        const {onBodyMouseDown} = this.props;

        if( onBodyMouseDown && typeof onBodyMouseDown === 'function' )
            onBodyMouseDown(event);
    }

    @bind
    private _onCancelClicked(event:React.MouseEvent<any>):void
    {
        const {onClose} = this.props;

        onClose && onClose(event);
    }

    public render():JSX.Element
    {
        const {className, title, children, onClose, titleIntent = MDIntent.Default, titleClassName} = this.props;

        return (
            <div
                className={cx(styles.dialog, className)}
                onKeyPressCapture={this._onKeyPress}
                onMouseDown={this._onBodyMouseDown}
                tabIndex={0}
                ref={this._onRef}
            >
                {
                    title &&
                    <div className={cx(styles.title, titleIntent, titleClassName)}>
                        {title}
                    </div>
                }
                <div className={styles.content}>
                    {children}
                </div>
                {
                    onClose &&
                    <Button
                        icon={MDIcons.common.Close}
                        className={styles.xButton}
                        onClick={this._onCancelClicked}
                        style={ButtonStyle.SimpleSecondary}
                        size={ButtonSize.Large}
                    />
                }
            </div>
        );
    }
}
